import { FieldProps } from 'formik';
import * as React from 'react';
import { BaseCheckbox, IBaseCheckboxProps } from '../../checkbox';

type CheckboxFieldProps = IBaseCheckboxProps & FieldProps;

/**
 * Wrapper around CheckboxField to be able to work with Form components
 */
export const CheckboxField = React.memo<CheckboxFieldProps>(props => {
    const {
        field,
        form: { setFieldValue },
        ...customProps
    } = props;

    const fieldValue: any[] = field.value || [];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (fieldValue.includes(props.value)) {
            const nextValue = fieldValue.filter(value => value !== props.value);
            setFieldValue(field.name, nextValue);
        } else {
            const nextValue = fieldValue.concat(props.value);
            setFieldValue(field.name, nextValue);
        }
    };

    return (
        <BaseCheckbox {...field} onChange={handleChange} checked={fieldValue.includes(props.value)} {...customProps} />
    );
});
